// https://boost.allnetru.dev/api/documentation/partner#/Events%20catalog
import { createApi } from '@reduxjs/toolkit/query/react';
import {
  EventCatalogFilter,
  GetEventAutomationCatalogResponse,
  GetEventByIdFromCatalogResponse,
  GetEventCatalogResponse,
} from './models';
import { baseQueryWithReauth } from '../../main/baseQueryWithReauth';
const partner_event_catalog = `partner_event_catalog`;

export const partnerEventCatalog = createApi({
  reducerPath: partner_event_catalog,
  baseQuery: baseQueryWithReauth,
  tagTypes: [partner_event_catalog],
  endpoints: (build) => ({
    getEventCatalog: build.query<
      GetEventCatalogResponse,
      { filters: EventCatalogFilter; page: number }
    >({
      query: ({ filters, page }) => {
        const statusesQueryString = Array.isArray(filters?.statuses)
          ? filters.statuses.map((id) => `filters[statuses][]=${id}`).join('&')
          : '';

        const categoriesQueryString = Array.isArray(filters?.categories)
          ? filters.categories.map((id) => `filters[categories][]=${id}`).join('&')
          : '';

        const locationsQueryString = Array.isArray(filters?.locations)
          ? filters.locations.map((id) => `filters[locations][]=${id}`).join('&')
          : '';
        const pageQueryString = page ? `page=${page}` : '';

        const queryString = [
          statusesQueryString,
          categoriesQueryString,
          locationsQueryString,
          pageQueryString,
        ]
          .filter(Boolean)
          .join('&');

        const params = {
          'filters[search]': filters?.search || undefined,
          'filters[date][from]': filters?.date?.from ? filters?.date?.from : undefined,
          'filters[date][to]': filters?.date?.to ? filters?.date?.to : undefined,
        };
        return {
          url: `/partner/events/catalog${queryString.length ? '?' + queryString : ''}`,
          method: 'GET',
          headers: {
            Accept: 'application/json',
          },
          //ASAP: use queryString only? check for bugs
          params,
        };
      },
      providesTags: [partner_event_catalog],
    }),
    getEventByIdFromCatalog: build.query<GetEventByIdFromCatalogResponse, { id: string }>({
      query: ({ id }) => ({
        url: `/partner/events/catalog/${id}`,
        headers: {
          Accept: 'application/json', // Specify JSON response
        },
      }),
      providesTags: [partner_event_catalog],
    }),
    getAutomationEventCatalog: build.query<
      GetEventAutomationCatalogResponse,
      { filters: EventCatalogFilter; page: number }
    >({
      query: ({ filters, page }) => {
        const statusesQueryString = Array.isArray(filters?.statuses)
          ? filters.statuses.map((id) => `filters[statuses][]=${id}`).join('&')
          : '';

        const categoriesQueryString = Array.isArray(filters?.categories)
          ? filters.categories.map((id) => `filters[categories][]=${id}`).join('&')
          : '';

        const locationsQueryString = Array.isArray(filters?.locations)
          ? filters.locations.map((id) => `filters[locations][]=${id}`).join('&')
          : '';
        const pageQueryString = page ? `page=${page}` : '';

        const queryString = [
          statusesQueryString,
          categoriesQueryString,
          locationsQueryString,
          pageQueryString,
        ]
          .filter(Boolean)
          .join('&');

        const params = {
          'filters[search]': filters?.search || undefined,
          'filters[date][from]': filters?.date?.from ? filters?.date?.from : undefined,
          'filters[date][to]': filters?.date?.to ? filters?.date?.to : undefined,
        };
        return {
          url: `/partner/automation/events/catalog${queryString.length ? '?' + queryString : ''}`,
          method: 'GET',
          headers: {
            Accept: 'application/json',
          },
          //ASAP: use queryString only? check for bugs
          params,
        };
      },
      providesTags: [partner_event_catalog],
    }),
    postAutomationEventByIdFromCatalog: build.mutation<
      GetEventByIdFromCatalogResponse,
      { id: number }
    >({
      query: ({ id }) => ({
        url: `/partner/automation/events/catalog/${id}/automate`,
        headers: {
          Accept: 'application/json', // Specify JSON response
        },
        method: 'POST',
        providesTags: [partner_event_catalog],
      }),
    }),
  }),
});

export const {
  useGetEventByIdFromCatalogQuery,
  useGetEventCatalogQuery,
  useGetAutomationEventCatalogQuery,
  usePostAutomationEventByIdFromCatalogMutation,
} = partnerEventCatalog;
